export const AG_GRID_LOCALE_KR = {
  // Set Filter
  selectAll: '(전체 선택)',
  selectAllSearchResults: '(검색 결과 모두 선택)',
  addCurrentSelectionToFilter: '현재 선택을 필터에 추가',
  searchOoo: '검색...',
  blanks: '(공백)',
  noMatches: '일치하는 항목 없음',

  // Number Filter & Text Filter
  filterOoo: '필터...',
  equals: '같음',
  notEqual: '같지 않음',
  blank: '공백',
  notBlank: '공백이 아님',
  empty: '선택',

  // Number Filter
  lessThan: '미만',
  greaterThan: '초과',
  lessThanOrEqual: '이하',
  greaterThanOrEqual: '이상',
  inRange: '범위',
  inRangeStart: '부터',
  inRangeEnd: '까지',

  // Text Filter
  contains: '포함',
  notContains: '포함하지 않음',
  startsWith: '시작',
  endsWith: '끝',

  // Date Filter
  dateFormatOoo: 'yyyy-mm-dd',
  before: '이전',
  after: '이후',

  // Filter Buttons
  applyFilter: '적용',
  resetFilter: '재설정',
  clearFilter: '지우기',
  cancelFilter: '취소',

  // Filter Titles
  textFilter: '텍스트 필터',
  numberFilter: '숫자 필터',
  dateFilter: '날짜 필터',
  setFilter: '집합 필터',

  // Group Column Filter
  groupFilterSelect: '필드 선택:',

  // Advanced Filter
  advancedFilterContains: '포함',
  advancedFilterNotContains: '포함하지 않음',
  advancedFilterTextEquals: '같음',
  advancedFilterTextNotEqual: '같지 않음',
  advancedFilterStartsWith: '시작',
  advancedFilterEndsWith: '끝',
  advancedFilterBlank: '공백',
  advancedFilterNotBlank: '공백이 아님',
  advancedFilterEquals: '=',
  advancedFilterNotEqual: '!=',
  advancedFilterGreaterThan: '>',
  advancedFilterGreaterThanOrEqual: '>=',
  advancedFilterLessThan: '<',
  advancedFilterLessThanOrEqual: '<=',
  advancedFilterTrue: '참',
  advancedFilterFalse: '거짓',
  advancedFilterAnd: '그리고',
  advancedFilterOr: '또는',
  advancedFilterApply: '적용',
  advancedFilterBuilder: '빌더',
  advancedFilterValidationMissingColumn: '열이 없음',
  advancedFilterValidationMissingOption: '옵션이 없음',
  advancedFilterValidationMissingValue: '값이 없음',
  advancedFilterValidationInvalidColumn: '열을 찾을 수 없음',
  advancedFilterValidationInvalidOption: '옵션을 찾을 수 없음',
  advancedFilterValidationMissingQuote: '값의 끝에 따옴표가 없음',
  advancedFilterValidationNotANumber: '값이 숫자가 아님',
  advancedFilterValidationInvalidDate: '값이 날짜가 아님',
  advancedFilterValidationMissingCondition: '조건이 없음',
  advancedFilterValidationJoinOperatorMismatch: '조건 내의 결합 연산자가 모두 같아야 함',
  advancedFilterValidationInvalidJoinOperator: '결합 연산자를 찾을 수 없음',
  advancedFilterValidationMissingEndBracket: '닫는 괄호가 없음',
  advancedFilterValidationExtraEndBracket: '여분의 닫는 괄호',
  advancedFilterValidationMessage: '식에 오류가 있습니다. ${variable} - ${variable}.',
  advancedFilterValidationMessageAtEnd: '식에 오류가 있습니다. ${variable} 끝.',
  advancedFilterBuilderTitle: '고급 필터',
  advancedFilterBuilderApply: '적용',
  advancedFilterBuilderCancel: '취소',
  advancedFilterBuilderAddButtonTooltip: '필터 또는 그룹 추가',
  advancedFilterBuilderRemoveButtonTooltip: '제거',
  advancedFilterBuilderMoveUpButtonTooltip: '위로 이동',
  advancedFilterBuilderMoveDownButtonTooltip: '아래로 이동',
  advancedFilterBuilderAddJoin: '그룹 추가',
  advancedFilterBuilderAddCondition: '필터 추가',
  advancedFilterBuilderSelectColumn: '열 선택',
  advancedFilterBuilderSelectOption: '옵션 선택',
  advancedFilterBuilderEnterValue: '값 입력...',
  advancedFilterBuilderValidationSelectColumn: '열을 선택해야 함',
  advancedFilterBuilderValidationSelectOption: '옵션을 선택해야 함',
  advancedFilterBuilderValidationEnterValue: '값을 입력해야 함',

  // Side Bar
  columns: '열',
  filters: '필터',

  // columns tool panel
  pivotMode: '피벗 모드',
  groups: '행 그룹',
  rowGroupColumnsEmptyMessage: '여기로 드래그하여 행 그룹화',
  values: '값',
  valueColumnsEmptyMessage: '여기로 드래그하여 집계',
  pivots: '열 레이블',
  pivotColumnsEmptyMessage: '여기로 드래그하여 열 레이블 설정',

  // Header of the Default Group Column
  group: '그룹',

  // Row Drag
  rowDragRows: '행',
  rowDragRow: '행',

  // Other
  loadingOoo: '로딩 중...',
  loadingError: '오류',
  noRowsToShow: '표시할 행이 없습니다',
  enabled: '활성화',

  // Menu
  pinColumn: '열 고정',
  pinLeft: '왼쪽 고정',
  pinRight: '오른쪽 고정',
  noPin: '고정 해제',
  valueAggregation: '값 집계',
  noAggregation: '없음',
  autosizeThisColumn: '이 열 자동 크기 조정',
  autosizeAllColumns: '모든 열 자동 크기 조정',
  groupBy: '그룹화',
  ungroupBy: '그룹화 해제',
  addToValues: '${variable}을(를) 값에 추가',
  removeFromValues: '${variable}을(를) 값에서 제거',
  addToLabels: '${variable}을(를) 레이블에 추가',
  removeFromLabels: '${variable}을(를) 레이블에서 제거',
  resetColumns: '열 재설정',
  expandAll: '모두 펼치기',
  collapseAll: '모두 접기',
  copy: '복사',
  ctrlC: 'Ctrl+C',
  ctrlX: 'Ctrl+X',
  copyWithHeaders: '헤더와 함께 복사',
  copyWithGroupHeaders: '그룹 헤더와 함께 복사',
  cut: '잘라내기',
  paste: '붙여넣기',
  ctrlV: 'Ctrl+V',
  export: '내보내기',
  csvExport: 'CSV 내보내기',
  excelExport: 'Excel 내보내기',
  columnFilter: '열 필터',
  columnChooser: '열 선택',
  sortAscending: '오름차순 정렬',
  sortDescending: '내림차순 정렬',
  sortUnSort: '정렬 해제',

  // Enterprise Menu Aggregation and Status Bar
  sum: '합계',
  first: '첫 번째',
  last: '마지막',
  min: '최소',
  max: '최대',
  none: '없음',
  count: '개수',
  avg: '평균',
  filteredRows: '필터됨',
  selectedRows: '선택됨',
  totalRows: '전체 행',
  totalAndFilteredRows: '행',
  more: '더 보기',
  to: '~',
  of: '/',
  page: '페이지',
  pageLastRowUnknown: '?',
  nextPage: '다음 페이지',
  lastPage: '마지막 페이지',
  firstPage: '첫 번째 페이지',
  previousPage: '이전 페이지',
  pageSizeSelectorLabel: '페이지 크기:',
  footerTotal: '총',

  // Pivoting
  pivotColumnGroupTotals: '합계',

  // Enterprise Menu (Charts)
  pivotChartAndPivotMode: '피벗 차트 및 피벗 모드',
  pivotChart: '피벗 차트',
  chartRange: '차트 범위',

  columnChart: '세로 막대형',
  groupedColumn: '그룹화',
  stackedColumn: '누적',
  normalizedColumn: '100% 누적',

  barChart: '가로 막대형',
  groupedBar: '그룹화',
  stackedBar: '누적',
  normalizedBar: '100% 누적',

  pieChart: '원형',
  pie: '원형',
  doughnut: '도넛',

  line: '선형',

  xyChart: 'X Y (분산형)',
  scatter: '분산형',
  bubble: '거품형',

  areaChart: '영역',
  area: '영역',
  stackedArea: '누적 영역',
  normalizedArea: '100% 누적 영역',

  histogramChart: '히스토그램',
  histogramFrequency: '빈도',

  combinationChart: '조합',
  columnLineCombo: '세로 막대 및 선형',
  AreaColumnCombo: '영역 및 세로 막대',

  // Charts
  pivotChartTitle: '피벗 차트',
  rangeChartTitle: '범위 차트',
  settings: '설정',
  data: '데이터',
  format: '서식',
  categories: '범주',
  defaultCategory: '(없음)',
  series: '계열',
  xyValues: 'X Y 값',
  paired: '쌍 모드',
  axis: '축',
  navigator: '네비게이터',
  color: '색상',
  thickness: '두께',
  xType: 'X 유형',
  automatic: '자동',
  category: '범주',
  number: '숫자',
  time: '시간',
  autoRotate: '자동 회전',
  xRotation: 'X 회전',
  yRotation: 'Y 회전',
  ticks: '눈금',
  width: '너비',
  height: '높이',
  length: '길이',
  padding: '패딩',
  spacing: '간격',
  chart: '차트',
  title: '제목',
  titlePlaceholder: '차트 제목 - 편집하려면 두 번 클릭',
  background: '배경',
  font: '글꼴',
  top: '위',
  right: '오른쪽',
  bottom: '아래',
  left: '왼쪽',
  labels: '레이블',
  size: '크기',
  minSize: '최소 크기',
  maxSize: '최대 크기',
  legend: '범례',
  position: '위치',
  markerSize: '마커 크기',
  markerStroke: '마커 선',
  markerPadding: '마커 패딩',
  itemSpacing: '항목 간격',
  itemPaddingX: '항목 패딩 X',
  itemPaddingY: '항목 패딩 Y',
  layoutHorizontalSpacing: '수평 간격',
  layoutVerticalSpacing: '수직 간격',
  strokeWidth: '선 두께',
  lineDash: '점선',
  offset: '오프셋',
  offsets: '오프셋',
  tooltips: '도구 설명',
  callout: '콜아웃',
  markers: '마커',
  shadow: '그림자',
  blur: '흐림',
  xOffset: 'X 오프셋',
  yOffset: 'Y 오프셋',
  lineWidth: '선 두께',
  normal: '일반',
  bold: '굵게',
  italic: '기울임꼴',
  boldItalic: '굵은 기울임꼴',
  predefined: '미리 정의됨',
  fillOpacity: '채우기 불투명도',
  strokeOpacity: '선 불투명도',
  histogramBinCount: '빈 개수',
  columnGroup: '세로 막대',
  barGroup: '가로 막대',
  pieGroup: '원형',
  lineGroup: '선형',
  scatterGroup: '분산형',
  areaGroup: '영역',
  histogramGroup: '히스토그램',
  combinationGroup: '조합',
  groupedColumnTooltip: '그룹화',
  stackedColumnTooltip: '누적',
  normalizedColumnTooltip: '100% 누적',
  groupedBarTooltip: '그룹화',
  stackedBarTooltip: '누적',
  normalizedBarTooltip: '100% 누적',
  pieTooltip: '원형',
  doughnutTooltip: '도넛',
  lineTooltip: '선형',
  groupedAreaTooltip: '그룹화',
  stackedAreaTooltip: '누적',
  normalizedAreaTooltip: '100% 누적',
  scatterTooltip: '분산형',
  bubbleTooltip: '거품형',
  histogramTooltip: '히스토그램',
  columnLineComboTooltip: '세로 막대 및 선형',
  areaColumnComboTooltip: '영역 및 세로 막대',
  customComboTooltip: '사용자 지정 조합',
  noDataToChart: '차트에 표시할 데이터가 없습니다.',
  pivotChartRequiresPivotMode: '피벗 차트에는 피벗 모드를 활성화해야 합니다.',
  chartSettingsToolbarTooltip: '메뉴',
  chartLinkToolbarTooltip: '그리드에 연결',
  chartUnlinkToolbarTooltip: '그리드에서 연결 해제',
  chartDownloadToolbarTooltip: '차트 다운로드',
  seriesChartType: '계열 차트 유형',
  seriesType: '계열 유형',
  secondaryAxis: '보조 축',

  // ARIA
  ariaChecked: '선택됨',
  ariaColumn: '열',
  ariaColumnGroup: '열 그룹',
  ariaColumnList: '열 목록',
  ariaColumnSelectAll: '모든 열 선택',
  ariaDateFilterInput: '날짜 필터 입력',
  ariaDefaultListName: '목록',
  ariaFilterColumnsInput: '열 필터 입력',
  ariaFilterFromValue: '다음 값부터 필터링',
  ariaFilterInput: '필터 입력',
  ariaFilterList: '필터 목록',
  ariaFilterToValue: '다음 값까지 필터링',
  ariaFilterValue: '필터 값',
  ariaFilteringOperator: '필터링 연산자',
  ariaHidden: '숨김',
  ariaIndeterminate: '미결정',
  ariaInputEditor: '입력 편집기',
  ariaMenuColumn: '열 ${variable}을(를) 열려면 ALT DOWN을 누르세요',
  ariaRowDeselect: '이 행을 선택 해제하려면 SPACE를 누르세요',
  ariaRowSelectAll: '모든 행을 선택하려면 SPACE를 누르세요',
  ariaRowToggleSelection: '행 선택을 토글하려면 SPACE를 누르세요',
  ariaRowSelect: '이 행을 선택하려면 SPACE를 누르세요',
  ariaSearch: '검색',
  ariaSortableColumn: '정렬하려면 ENTER를 누르세요',
  ariaToggleFilter: '필터를 토글하려면 ENTER를 누르세요',
  ariaToggleSelection: '선택을 토글하려면 SPACE를 누르세요',
  ariaUnchecked: '선택 안 됨',
  ariaVisible: '표시됨',
  ariaSearchFilterValues: '필터 값 검색',

  // ARIA Labels for Drop Zones
  ariaRowGroupDropZonePanelLabel: '행 그룹',
  ariaValuesDropZonePanelLabel: '값',
  ariaPivotDropZonePanelLabel: '열 레이블',
  ariaDropZoneColumnComponentDescription: '제거하려면 DELETE를 누르세요',
  ariaDropZoneColumnValueItemDescription: '집계 유형을 변경하려면 ENTER를 누르세요',
  ariaDropZoneColumnGroupItemDescription: '정렬하려면 ENTER를 누르세요',

  // used for aggregate drop zone, format: {aggregation}{ariaDropZoneColumnComponentAggFuncSeperator}{column name}
  ariaDropZoneColumnComponentAggFuncSeperator: ' / ',
  ariaDropZoneColumnComponentSortAscending: '오름차순',
  ariaDropZoneColumnComponentSortDescending: '내림차순',

  // ARIA Labels for Dialogs
  ariaLabelColumnMenu: '열 메뉴',
  ariaLabelCellEditor: '셀 편집기',
  ariaLabelDialog: '대화상자',
  ariaLabelSelectField: '필드 선택',
  ariaLabelTooltip: '도구 설명',
  ariaLabelContextMenu: '상황별 메뉴',
  ariaLabelSubMenu: '하위 메뉴',
  ariaLabelAggregationFunction: '집계 함수',

  // ARIA Labels for the Side Bar
  ariaColumnPanelList: '열 목록',
  ariaFilterPanelList: '필터 목록',

  // Number Format (Status Bar, Pagination Panel)
  thousandSeparator: ',',
  decimalSeparator: '.',

  // Data types
  true: '참',
  false: '거짓',
  invalidDate: '잘못된 날짜',
  invalidNumber: '잘못된 숫자',
  january: '1월',
  february: '2월',
  march: '3월',
  april: '4월',
  may: '5월',
  june: '6월',
  july: '7월',
  august: '8월',
  september: '9월',
  october: '10월',
  november: '11월',
  december: '12월',
};